import styles from './MwdTooltip.module.css';

const sumFromGekoppeldeInzetten = (data, field) =>
  (data.gekoppeldeInzetten ?? []).reduce((sum, inzet) => {
    const value = inzet.treinSamenstelling?.[field];
    return inzet.eenheid?.nummer === 'MANCO' || typeof value !== 'number' ? sum : sum + value;
  }, 0);

const getBezettingsStatusLabel = (
  prognose: number,
  comfortabelNorm: number,
  acceptabelNorm: number,
  volNorm: number,
) => {
  if (!comfortabelNorm) return 'Bezetting';
  if (prognose < comfortabelNorm * 0.5) return 'Ruim onder comfortabel norm';
  if (prognose <= comfortabelNorm) return 'Onder comfortabel norm';
  if (acceptabelNorm > 0 && prognose <= acceptabelNorm) return 'Boven comfortabel norm';
  if (volNorm > 0 && prognose <= volNorm) return 'Boven acceptabel norm';
  return 'Volnorm';
};

const DetailPanelOnPrognoseTooltipInformation = ({ data }) => {
  const { station, totalZitPlaatsen, totalComfortabelNorm, totalAcceptabelNorm, totalVolNorm, showAllStops } = data;
  const prognose = showAllStops ? station?.prognose : (station?.highestPrognose ?? 0);
  const hasDifferentPrognoses =
    station?.prognose !== station?.highestPrognose || station?.prognose !== station?.lowestPrognose;
  const bezettingTotAcceptabelNorm = totalAcceptabelNorm > 0 ? Math.round((prognose / totalAcceptabelNorm) * 100) : 0;
  const restCapaciteitTotVol = totalVolNorm > 0 ? Math.max(totalVolNorm - prognose, 0) : null;
  const statusLabel = getBezettingsStatusLabel(prognose, totalComfortabelNorm, totalAcceptabelNorm, totalVolNorm);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', overflow: 'hidden' }}>
      {prognose > 0 && (
        <>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>{statusLabel}</div>
          <div>
            <span style={{ fontWeight: 400 }}>
              {showAllStops
                ? 'Reizigersprognose: '
                : hasDifferentPrognoses
                  ? 'Reizigersprognose (max): '
                  : 'Reizigersprognose: '}
            </span>
            <span style={{ fontWeight: 500 }}>{prognose}</span>
          </div>
          <div>
            <span style={{ fontWeight: 400 }}>Zitplaatsen: </span>
            <span style={{ fontWeight: 500 }}>{totalZitPlaatsen}</span>
          </div>
          <div>
            <span style={{ fontWeight: 400 }}>
              Bezetting t.o.v.
              <br />
              acceptabel norm:{' '}
            </span>
            <span style={{ fontWeight: 500 }}>{bezettingTotAcceptabelNorm}%</span>
          </div>
          <div>
            <span style={{ fontWeight: 400 }}>Restcapaciteit tot vol: </span>
            <span style={{ fontWeight: 500 }}>{restCapaciteitTotVol ?? '-'}</span>
          </div>
        </>
      )}
    </div>
  );
};

const DetailPanelOnPrognoseTooltipContent = ({ data, arrowPosition }) => {
  const totalZitPlaatsen = (data.zitPlaatsen ?? 0) + sumFromGekoppeldeInzetten(data, 'aantalZitplaatsen');
  const totalComfortabelNorm = (data.comfortabelNorm ?? 0) + sumFromGekoppeldeInzetten(data, 'comfortabelNorm');
  const totalAcceptabelNorm = (data.acceptabelNorm ?? 0) + sumFromGekoppeldeInzetten(data, 'acceptabelNorm');
  const totalVolNorm = (data.volNorm ?? 0) + sumFromGekoppeldeInzetten(data, 'volNorm');
  const comfortNormForDisplay = totalComfortabelNorm || totalZitPlaatsen;

  return (
    <div
      data-testid='detail-panel-tooltip'
      className={`${arrowPosition === 'bottom' ? styles.legendRightBottomTooltipStyle : styles.legendRightTopTooltipStyle} ${styles.detailPanelOnPrognoseTooltipStyle}`}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <DetailPanelOnPrognoseTooltipInformation
          data={{
            ...data,
            totalZitPlaatsen,
            totalComfortabelNorm: comfortNormForDisplay,
            totalAcceptabelNorm,
            totalVolNorm,
          }}
        />
      </div>
    </div>
  );
};

export default DetailPanelOnPrognoseTooltipContent;
